/* istanbul ignore file */
const styles = ({ palette: { grey, primary, text }, spacing: { unit }, typography }) => ({
  row: {
    margin: `${unit * 2}px ${unit * 1.5}px`
  },
  oriInfoRow: {
    marginTop: unit * 2
  },
  root: {
    borderTop: `1px solid ${grey.G200}`,
    padding: `${unit * 4}px 0 0`,

    '& .panel': {
      margin: 0,
      padding: `${unit * 3.75}px 0`
    },

    '& .panel + .panel': {
      borderTop: `1px solid ${grey.G200}`
    }
  },
  typeofIntBankCodes: {
    marginBOttom: 20
  },
  header: {
    fontSize: typography.title.fontSize,
    fontWeight: typography.fontWeightMedium
  },
  fieldsContainer: {
    display: 'block',
    marginTop: unit * 2.5,
    padding: `0 ${unit * 1.75}px`,
    '& .form-control': {
      margin: 0
    },
    '& label': {
      color: grey.G600,
      display: 'block',
      textTransform: 'uppercase'
    },
    '& .field-status': {
      float: 'right',
      color: grey.G600,
      fontSize: unit * 1.5,
      fontWeight: typography.fontWeightRegular,
      textTransform: 'capitalize'
    },
    '& [class*=col-]': {
      display: 'inline-block',
      float: 'none',
      verticalAlign: 'middle'
    }
  },
  fullWidth: {
    flexBasis: '100%'
  },
  add2ndBankLink: {
    '&.btn.btn': {
      alignSelf: 'flex-start',
      color: primary.normal,
      textDecoration: 'none',
      cursor: 'pointer',
      paddingLeft: 16
    }
  },
  add2ndBankLinkPos: {
    position: 'relative',
    top: 24
  },
  bankDropDown: {
    '& .flex-dropdown': {
      marginTop: unit * 2,
      marginBottom: unit,
      position: 'relative'
    },
    display: 'flex',
    flexDirection: 'column',
    '& label': {
      display: 'block'
    }
  },
  secondDropdownVisible: {
    marginTop: 20
  },
  dropdown: {
    marginTop: 16,
    marginLeft: -16
  },
  adresses: {
    marginTop: unit,
    display: 'flex',
    flexDirection: 'column',
    '& span': {
      fontSize: unit * 1.5,
      color: text.dark,
      textTransform: 'uppercase'
    }
  }
});

export default styles;
